import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import detector from 'i18next-browser-languagedetector';
import danishTranslations from 'assets/translations/da.json';
import englishTranslations from 'assets/translations/en.json';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: englishTranslations,
    },
    da: {
        translation: danishTranslations,
    },
};

i18n.use(detector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: 'da',
        fallbackLng: 'da',

        keySeparator: '.', // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false, // react already safes from xss
        },
    });

export default i18n;
